import { render, staticRenderFns } from "./RoundConfirm.vue?vue&type=template&id=860b8bf0&scoped=true&"
import script from "./RoundConfirm.vue?vue&type=script&lang=js&"
export * from "./RoundConfirm.vue?vue&type=script&lang=js&"
import style0 from "./RoundConfirm.vue?vue&type=style&index=0&id=860b8bf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "860b8bf0",
  null
  
)

export default component.exports